/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageDelete_lists$ref: FragmentReference;
declare export opaque type MessageDelete_lists$fragmentType: MessageDelete_lists$ref;
export type MessageDelete_lists = {|
  +id: string,
  +$refType: MessageDelete_lists$ref,
|};
export type MessageDelete_lists$data = MessageDelete_lists;
export type MessageDelete_lists$key = {
  +$data?: MessageDelete_lists$data,
  +$fragmentRefs: MessageDelete_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageDelete_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '7ef233db4f0758a8bdffd6e06409c189';

module.exports = node;
